import React, { useState } from 'react';
import './style.css';

export default function AntsTalk(){
    const [downloading, setDownloading] = useState(false);

    const handleDownload = (url) => {
        setDownloading(true);
        window.location.href = url;
        setTimeout(() => setDownloading(false), 2000);
    };

    // 채팅 아이콘 SVG
    const ChatIcon = () => (
        <svg viewBox="0 0 100 100" className="chat-icon">
            <defs>
                <linearGradient id="chatGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#01BCD6"/>
                    <stop offset="100%" stopColor="#006674"/>
                </linearGradient>
            </defs>
            <rect x="10" y="15" width="80" height="55" rx="10" fill="url(#chatGradient)"/>
            <polygon points="25,70 35,70 20,85" fill="url(#chatGradient)"/>
            <circle cx="35" cy="42" r="5" fill="#fff"/>
            <circle cx="50" cy="42" r="5" fill="#fff"/>
            <circle cx="65" cy="42" r="5" fill="#fff"/>
        </svg>
    );

    // 기능 아이콘들
    const FeatureIcon = ({ type }) => {
        const icons = {
            chat: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
            ),
            group: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
            ),
            file: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                </svg>
            ),
            security: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
            ),
            notification: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
            ),
            search: (
                <svg viewBox="0 0 24 24" fill="none" stroke="#01BCD6" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
            )
        };
        return icons[type] || null;
    };

    return(
        <div className='AntsTalkContents'>
            <div className='HomeContainer'>
                {/* 히어로 섹션 */}
                <div className="AntsTalkHero">
                    <div className="HeroContent">
                        <div className="HeroText">
                            <h1>AntsTalk</h1>
                            <p className="HeroSubtitle">실시간 소통의 새로운 기준</p>
                            <p className="HeroDesc">빠르고 안전한 메시징으로 팀과 함께 일하세요.<br/>앤츠네스트의 공식 메신저입니다.</p>
                            <button
                                className={`DownloadBtn ${downloading ? 'downloading' : ''}`}
                                onClick={() => handleDownload('https://file.skynet.re.kr/biz_antsnest/f20260125_4yu6b3.exe')}
                                disabled={downloading}
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="download-icon">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                    <polyline points="7 10 12 15 17 10"/>
                                    <line x1="12" y1="15" x2="12" y2="3"/>
                                </svg>
                                {downloading ? '다운로드 중...' : 'Windows 다운로드'}
                            </button>
                        </div>
                        <div className="HeroIcon">
                            <ChatIcon />
                        </div>
                    </div>
                </div>

                {/* 기능 섹션 */}
                <div className="AntsTalkFeatures">
                    <h2>주요 기능</h2>
                    <div className="FeatureGrid">
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="chat" />
                            </div>
                            <h3>실시간 채팅</h3>
                            <p>1:1 및 그룹 채팅으로 빠른 소통</p>
                        </div>
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="group" />
                            </div>
                            <h3>팀 협업</h3>
                            <p>프로젝트별 채널로 체계적 관리</p>
                        </div>
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="file" />
                            </div>
                            <h3>파일 공유</h3>
                            <p>문서, 이미지, 동영상 간편 전송</p>
                        </div>
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="security" />
                            </div>
                            <h3>보안</h3>
                            <p>종단간 암호화로 안전한 대화</p>
                        </div>
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="notification" />
                            </div>
                            <h3>알림 설정</h3>
                            <p>맞춤형 알림으로 집중 모드</p>
                        </div>
                        <div className="FeatureCard">
                            <div className="FeatureIconBox">
                                <FeatureIcon type="search" />
                            </div>
                            <h3>메시지 검색</h3>
                            <p>필요한 정보를 빠르게 찾기</p>
                        </div>
                    </div>
                </div>

                {/* 하단 CTA */}
                <div className="AntsTalkCTA">
                    <h2>지금 바로 시작하세요</h2>
                    <p>앤츠톡과 함께 더 효율적인 팀 커뮤니케이션을 경험하세요</p>
                    <button
                        className={`DownloadBtn large ${downloading ? 'downloading' : ''}`}
                        onClick={() => handleDownload('https://file.skynet.re.kr/biz_antsnest/f20260125_4yu6b3.exe')}
                        disabled={downloading}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="download-icon">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="7 10 12 15 17 10"/>
                            <line x1="12" y1="15" x2="12" y2="3"/>
                        </svg>
                        {downloading ? '다운로드 중...' : 'AntsTalk 다운로드'}
                    </button>
                </div>
            </div>
        </div>
    );
}
